import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { CustomFieldPreset } from 'types/customField';

type CustomFieldTarget = 'eleve' | 'cahierjournal';

interface Params {
  target: CustomFieldTarget;
  cycles: string[];
}

function fetchData(params: Params) {
  return request('/presets/customfields', {
    method: 'GET',
    params,
  }).then<CustomFieldPreset[]>(res => res.data || []);
}

export const useCustomFieldPresets = (params: Params) =>
  useQuery({
    queryKey: ['customFieldPresets', params],
    queryFn: () => fetchData(params),
    staleTime: 1000 * 60 * 60,
  });
